import _ from 'lodash';
import { safeJSONParse } from '@/utils';

export const partnerRuleErrorCodeMap = {
  preCheckWithPartnerFail: {
    code: '380000',
    tracking: 'pre check fail with partner referral',
    reason: '',
  },
  notPartnerRefer: {
    code: '380001',
    tracking: 'without partner referral',
    reason: '',
  },
  soldToCountry: {
    code: '380002',
    tracking: 'country',
    reason: '',
  },
  ipLocationCountry: {
    code: '380003',
    tracking: 'country',
    reason: '',
  },
  accountType: {
    code: '380004',
    tracking: 'accountType',
    reason: '',
  },
  promotionPlanMatch: {
    code: '380005',
    tracking: 'selected plan does not match promotion',
    reason: '',
  },
  promotionCouponMatch: {
    code: '380006',
    tracking: 'input coupon does not match promotion coupon',
    reason: '',
  },
  promotionBindCouponValidFail: {
    code: '380007',
    tracking: 'partner coupon validate fail',
    reason: '',
  },
};

export const messageRuleCodeMap = {
  accountType: 'eligibleAccountType',
  country: 'eligibleCountry',
  planList: 'eligiblePlanList',
  abTest: 'abTest',
  monthlyPreloadPlan: 'monthlyPreloadPlan',
  annualPreloadPlan: 'annualPreloadPlan',
};

export const PARTNER_REFER_KEY_MAP = {
  jointsaleCodeKey: 'jointsale',
  referralCodeKey: 'referralCode',
};

export const partnerReferImageFileMap = {
  perplexity: {
    planCardLogo: require('@/assets/partner/perplexity/logo.png'),
    offerDetailLogo: require('@/assets/partner/perplexity/offer-detail-logo.png'),
    offerPreloadFeature: require('@/assets/partner/perplexity/feature.png'),
    successLogoIcon: require('@/assets/partner/perplexity/success-logo-icon.png'),
  },
  honeybook: {
    planCardLogo: require('@/assets/partner/honeybook/logo.png'),
    offerDetailLogo: require('@/assets/partner/honeybook/offer-detail-logo.png'),
  },
  mobisystems: {
    offerDetailLogo: require('@/assets/partner/mobisystems/offer-detail-logo.png'),
  },
  dropbox: {
    offerDetailLogo: require('@/assets/partner/dropbox/offer-detail-logo.png'),
  },
};

export const partnerCampaignTest = {
  version: _.get(window, 'campaignFlags.partnerCampaignTestVersion'),
  setDefaultVersion(version) {
    if (!this.version) {
      this.version = version;
    }
  },
};

export const partnerNameMapping = {
  perplexity: 'perplexity',
};

// new properties in rule table, should fe to format
export const partnerFeaturePropertiesTarget = {
  booleanProps: {
    keys: [
      'containDynamicImageFile',
      'containDynamicDistributeQuantity',
      'offerDetailBtnFromOpConfig',
      'renamePartner',
      'hiddenCouponForm',
      'useInSoftBundle',
      'validateByCoupon'
    ],
    toValue(v) {
      return v === 'true';
    },
  },
  stringArrayWithCommaProps: {
    keys: [
      messageRuleCodeMap.abTest,
      messageRuleCodeMap.monthlyPreloadPlan,
      messageRuleCodeMap.annualPreloadPlan,
    ],
    toValue(v) {
      return _.split(v, ',');
    },
  },
  stringJsonProps: {
    keys: ['softBundleConfig', 'softBundleConfigV2', 'couponConfig'],
    toValue(v) {
      return safeJSONParse(v);
    },
  },
  getFormatedValue(key, value) {
    if (this.booleanProps.keys.includes(key)) {
      return this.booleanProps.toValue(value);
    }

    if (this.stringArrayWithCommaProps.keys.includes(key)) {
      return this.stringArrayWithCommaProps.toValue(value);
    }

    if (this.stringJsonProps.keys.includes(key)) {
      return this.stringJsonProps.toValue(value);
    }

    return value;
  },
};
